import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CarrierModel } from '../models/carriers.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarriersApiService {
  private readonly BASE: string = `${environment.inventoryApiUrl}/Carriers`;

  private readonly GET_ALL = (): string => `${this.BASE}`;
  private readonly GET_BY_ID = (id: number): string => `${this.BASE}/${id}`;
  private readonly CREATE = (): string => `${this.BASE}`;
  private readonly UPDATE = (id: number): string => `${this.BASE}/${id}`;
  private readonly DELETE = (id: number): string => `${this.BASE}/${id}`;

  constructor(private readonly http: HttpClient) {}

  getCarriers(queryParams: Record<string, any>): Observable<CarrierModel[]> {
    const params: HttpParams = new HttpParams({ fromObject: queryParams });
    return this.http.get<CarrierModel[]>(this.GET_ALL(), { params });
  }

  getCarrierById(id: number): Observable<CarrierModel> {
    return this.http.get<CarrierModel>(this.GET_BY_ID(id));
  }

  createCarrier(data: CarrierModel): Observable<CarrierModel> {
    return this.http.post<CarrierModel>(this.CREATE(), data);
  }

  updateCarrier(id: number, data: CarrierModel): Observable<CarrierModel> {
    return this.http.put<CarrierModel>(this.UPDATE(id), data);
  }

  deleteCarrier(id: number): Observable<void> {
    return this.http.delete<void>(this.DELETE(id));
  }

}
